export function getMarketingTheme(isDark) {
  return {
    pageBg: isDark ? "#020617" : "#f8fafc",
    pageGradient: isDark
      ? "radial-gradient(circle at top left, rgba(37,99,235,0.14), transparent 28%), radial-gradient(circle at top right, rgba(124,58,237,0.12), transparent 24%)"
      : "none",

    heroBg: isDark
      ? "radial-gradient(circle at top left, rgba(37,99,235,0.16), transparent 30%), radial-gradient(circle at top right, rgba(124,58,237,0.12), transparent 26%), #020617"
      : "radial-gradient(circle at top left, rgba(37,99,235,0.10), transparent 30%), radial-gradient(circle at top right, rgba(124,58,237,0.08), transparent 26%), #f8fafc",

    sectionBg: "transparent",
    cardBg: isDark ? "rgba(15,23,42,0.78)" : "#ffffff",
    cardBgStrong: isDark ? "rgba(15,23,42,0.92)" : "#ffffff",
    cardBgSoft: isDark ? "rgba(30,41,59,0.72)" : "#f8fafc",

    border: isDark ? "rgba(148,163,184,0.18)" : "#e5e7eb",
    borderStrong: isDark ? "rgba(148,163,184,0.28)" : "#d1d5db",

    text: isDark ? "#f8fafc" : "#111827",
    textMuted: isDark ? "#94a3b8" : "#6b7280",
    textSoft: isDark ? "#cbd5e1" : "#374151",

    badgeBg: isDark ? "rgba(37,99,235,0.16)" : "#eef2ff",
    badgeText: isDark ? "#bfdbfe" : "#4338ca",

    tagBg: isDark ? "rgba(15,23,42,0.82)" : "#ffffff",
    tagText: isDark ? "#cbd5e1" : "#374151",

    panelBg: isDark ? "rgba(15,23,42,0.82)" : "#ffffff",
    panelSubtleBg: isDark ? "rgba(30,41,59,0.70)" : "#f8fafc",

    darkCtaBg: isDark
      ? "linear-gradient(135deg, rgba(15,23,42,0.96), rgba(49,46,129,0.96))"
      : "linear-gradient(135deg, #111827, #312e81)",

    darkCtaText: "#ffffff",
    darkCtaMuted: isDark ? "rgba(226,232,240,0.84)" : "rgba(255,255,255,0.82)",

    shadow: isDark
      ? "0 14px 40px rgba(2, 6, 23, 0.45)"
      : "0 12px 30px rgba(15, 23, 42, 0.06)",

    shadowSoft: isDark
      ? "0 10px 26px rgba(2, 6, 23, 0.34)"
      : "0 8px 24px rgba(15, 23, 42, 0.04)"
  };
}